//config constants
export const WORDPRESS_URL = 'https://eyeot.com/';
export const WS_ENDPOINT = 'wss://api.eyeot.com';
export const API_ENDPOINT = 'https://api.eyeot.com/';
//export const WS_ENDPOINT = 'ws://localhost:3001';
//export const API_ENDPOINT = 'http://localhost:3000/';
export const VERSION = "1.7";